{
  "titles": {
    "progressCreditLimitRequest": "Voortgang wijziging faciliteit",
    "signingAuthorities": "Ondertekenaar(s)"
  },
  "messages": {
    "sentAt": "Verstuurd op {date}",
    "collateralCompletedAt": "Gecontroleerd op {date} door {user}",
    "notAllStepsCompleted": "Er zijn nog stappen die voltooid moeten worden voordat de faciliteit geactiveerd kan worden.",
    "allStepsCompleted": "Alle controles zijn doorlopen en akkoord bevonden.",
    "facilityActivated": "De faciliteit is geactiveerd door {user} op {at}",
    "mustValidateRefinancing": "De eindcontrole op de zekerheden is nog niet afgerond.",
    "activateFacilityNoPermission": "Je hebt geen toestemming om de faciliteit te activeren"
  },
  "actions": {
    "uploadCollaterals": "Zekerheden uploaden",
    "activateFacility": "Faciliteit activeren",
    "validateRefinancing": "Naar zekerheden"
  },
  "steps": {
    "inProgress": {
      "CreditLimitRequestCreated": "De Offerte is verzonden",
      "Quote": "Offerte tekenen",
      "Sepa": "Automatische incasso machtiging tekenen",
      "Psd": "Bankrekeningen verbinden",
      "Collaterals": "Zekerheden en overige voorwaarden",
      "ActivateCreditLimit": "Wijziging faciliteit afronden"
    },
    "completed": {
      "CreditLimitRequestCreated": "De Offerte is verzonden",
      "Quote": "Offerte is getekend",
      "Sepa": "Automatische incasso machtiging is getekend",
      "Psd": "Bankrekeningen zijn verbonden",
      "Collaterals": "Zekerheden en overige voorwaarden zijn geüpload",
      "ActivateCreditLimit": "Wijziging faciliteit afgerond"
    }
  },
  "restartOnboardingDialog": {
    "fields": {
      "labels": {
        "signers": "Ondertekenaars",
        "facilitiesAndCollaterals": "Faciliteiten en/of zekerheden",
        "isQuoteInvalid": "Uitwerking rekening courant faciliteit in offerte is niet juist",
        "areCollateralsInvalid": "Zekerheden en overige voorwaarden zijn niet juist",
        "identityNotMatching": "De naam {name} komt niet volledig overeen met de naam uit de identiteitscontrole",
        "nameNotMatching": "De naam {name} komt niet overeen met de naam uit de identiteitscontrole",
        "dateOfBirthNotMatching": "De geboortedatum van {name} komt niet overeen met de geboortedatum uit de identiteitscontrole",
        "areSignerIdentityValidationsIncomplete": "Onjuiste ondertekenaar(s) of onvoldoende ondertekenaar(s) opgenomen in de offerte."
      }
    },
    "messages": {
      "intro": "Met deze handeling kan de wijziging van faciliteit van de klant geannuleerd worden. Kies hieronder de reden waarom de wijziging faciliteit geannuleerd moet worden en het systeem zal die stappen afwijzen en alles terugdraaien naar de situatie voor de start van deze wijziging.",
      "warning": "Let op: Indien een wijziging faciliteit alsnog gewenst is, dient dit proces opnieuw gestart te worden.\n\nOm de klant van deze annulering op de hoogte te brengen, vragen we je hieronder om de redenen te benoemen waarom deze wijziging geannuleerd moet worden.",
      "signers": "De ondertekenaars kunnen altijd worden aangepast als de wijziging offerte opnieuw wordt gestart onder \"gebruikers\". De aangevinkte redenen worden medegedeeld met de klant."
    },
    "titles": {
      "restartOnboarding": "Wijziging faciliteit annuleren",
      "facilitiesAndCollaterals": "Faciliteiten en/of zekerheden",
      "signers": "Ondertekenaars"
    },
    "actions": {
      "restartOnboarding": "Wijziging faciliteit annuleren"
    }
  },
  "validateQuoteSigners": {
    "titles": {
      "checkIdentity": "Identiteit(en) controleren",
      "signer": "Ondertekenaar"
    },
    "messages": {
      "signersChecked": "Alle bevoegdheden van de ondertekenaars zijn gecontroleerd en gevalideerd op volledigheid en juistheid door {name} op {at}",
      "financeReceiverNotCompleted": "De klant moet nog inloggen en de offerte tekenen.",
      "checkIdentity": "Controleer de identiteit op de getekende documenten.",
      "noSigners": "Er zijn nog geen ondertekenaars toegevoegd.",
      "noPermissions": "Je hebt geen toestemming om de identiteit(en) te controleren."
    },
    "actions": {
      "checkIdentity": "Identiteit(en) controleren",
      "restoreIdentityChecks": "Niet akkoord en herstel"
    },
    "identityValidation": {
      "steps": {
        "identity": "Identiteit(en)",
        "summary": "Samenvatting"
      }
    }
  }
}